module.exports = __webpack_public_path__ + "static/media/yikatong_cover.b13bb444.png";